<template>
  <b-card
      title="مدیریت ترم های زیره پلاس"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
<!--              <b-button-->
<!--                  class="mb-1 mr-auto ml-1"-->
<!--                  variant="primary"-->
<!--                  :to="{ name: 'adduserspecialdiet'}"-->
<!--              >-->
<!--                جدید-->
<!--              </b-button>-->
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="شناسه کاربری"
                    label-for="Id"
                >
                  <b-form-input
                      v-model="filterOptions.UserId"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                    label="موبایل یا ایمیل یا نام"
                    label-for="Mobile"
                >
                  <b-form-input
                      v-model="filterOptions.Username"
                      autocomplete="off"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="کارشناس تغذیه"
                    label-for="IsActive"
                >
                  <nutritionist-select v-model="filterOptions.NutritionistId" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="IsActive"
                >
                  <v-select
                      v-model="filterOptions.Status"
                      :options="enums('UserStatus')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="StartDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      type="date"
                      format="YYYY-MM-DD"
                      display-format="jYYYY-jMM-jD"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="مدت دوره"
                    label-for="DietDurationId"
                >
                  <dynamic-select
                      v-model="filterOptions.DietDurationId"
                      :url="$api.userspecialdiet.dietDurationAll"
                      method="post"
                      label="Title"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
              <b-button
                  variant="gradient-secondary"
                  class="mb-1 mr-1"
                  @click="exportExcel()"
              >
                                  خروجی اکسل
                <b-spinner  small v-if="excelLoading === true" variant="primary" ></b-spinner>

              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'updateuserspecialdiet', params: { id: data.value }}"
                class="font-weight-bold"
                :disabled="data.item.UserSpecialDiet == null"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(User)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
              <b-media
                  vertical-align="center"
                  style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                      :src="data.value.Image"
                  />
                </template>
                <span
                    class="font-weight-bold d-block text-nowrap"
                    style="color: #6e6b7b;"
                >
                  <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.value.Id }}</small>
              </b-media>
            </b-link>
          </template>

          <template #cell(StartDate)="data">
            <div style="width: 120px !important">
              ش: {{ data.value | date }}
              پ: {{data.item.EndDate | date}}
              <b-badge :variant="colors[data.item.DietType]">{{data.item.DietTypeText}}</b-badge>
            </div>

          </template>

          <template #cell(CreatedAt)="data">
            <span v-if="data.item.UserSpecialDiet">
              {{ data.item.UserSpecialDiet.CreatedAt | date }}
            </span>
          </template>

          <template #cell(Title)="data">
            <span v-if="data.item.UserSpecialDiet">
              {{ data.item.UserSpecialDiet.Title }}
            </span>
          </template>

          <template #cell(Status)="data">
            <b-badge
                v-if="data.item.User.Status >= 0"
                :variant="enums('UserStatus', 'value', data.item.User.Status, 'badge')"
            >
              {{ enums('UserStatus', 'value', data.item.User.Status, 'text') }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <template v-if="data.item.UserSpecialDiet != null" target="_blank" :href="'/userspecialdiet/pdf/regenerate?id=' + data.item.UserSpecialDiet.Id">

                <feather-icon
                    v-if="data.item.UserSpecialDiet.PdfPath"
                    icon="DownloadIcon"
                    size="16"
                    @click="downloadPdf(data.item.UserSpecialDiet.Id)"
                />
                <feather-icon
                    v-if="!downloading.includes('g'+data.item.UserSpecialDiet.Id)"
                    icon="RefreshCwIcon"
                    size="16"
                    class="ml-1"
                    @click="generatePdf(data.item.UserSpecialDiet.Id)"
                />
                <b-spinner
                    v-else
                    small
                    variant="secondary"
                    class="ml-1"
                    style="margin-bottom: 3px"
                />
              </template>
              <feather-icon
                  v-if="data.item.UserSpecialDiet == null"
                  icon="PlusSquareIcon"
                  size="16"
                  class="ml-1"
                  @click="showModal(data.item, true)"
              />
              <b-link v-else :to="{ name: 'updateuserspecialdiet', params: { id: data.item.UserSpecialDiet.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.UserSpecialDiet.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                    class="ml-1"
                />
              </b-link>

              <b-link target="_blank" :href="'/ticket/List?userid='+ data.item.User.Id">
                <i class="bx bx-support ml-1" style="font-size: 16px; vertical-align: middle;"></i>
              </b-link>

              <feather-icon
                  icon="MessageCircleIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="openNewTicket(data.item)"
              />

              <feather-icon
                  v-if="$can( 'show','NutritionistManager')"
                  icon="UserIcon"
                  class="ml-1"
                  @click="updateNutritionist(data.item)"
              />

              <feather-icon
                  v-if="data.item.UserSpecialDiet != null"
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.UserSpecialDiet.Id)"
              />
            </div>
          </template>
          <template #cell(dietManager2)="data">
            <div v-if="data.item.UserSpecialDiet">
            <span v-if="data.item.UserSpecialDiet.ChildInfo">
                           <div
                               class="text-nowrap"
                           >
                <feather-icon
                    v-if="data.item.UserSpecialDiet.ChildInfo.PdfPath"
                    icon="DownloadIcon"
                    size="16"
                    @click="downloadPdf(data.item.UserSpecialDiet.ChildInfo.Id)"
                />
                              <feather-icon
                                  v-if="!downloading.includes('g'+data.item.UserSpecialDiet.ChildInfo.Id)"
                                  icon="RefreshCwIcon"
                                  size="16"
                                  class="ml-1"
                                  @click="generatePdf(data.item.UserSpecialDiet.ChildInfo.Id)"
                              />
                   <b-spinner
                       v-else
                       small
                       variant="secondary"
                       class="ml-1"
                       style="margin-bottom: 3px"
                   />
                  <b-link :to="{ name: 'updateuserspecialdiet', params: { id: data.item.UserSpecialDiet.ChildInfo.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.UserSpecialDiet.ChildInfo.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                    class="ml-1"
                />
              </b-link>
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.UserSpecialDiet.ChildInfo.Id)"
              />
            </div>
            </span>
              <span v-else>
              <feather-icon
                  icon="PlusSquareIcon"
                  size="16"
                  @click="showModal(data.item, true,)"
              />
            </span>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
        v-model="isShow"
        v-if="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تخصیص رژیم"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
              label="نوع رژیم"
              label-for="DietType"
          >
            <v-select
                v-model="DietType"
                dir="rtl"
                :reduce="x => x.value"
                label="text"
                input-id="DietType"
                :clearable="false"
                :options="filteredDietTypes"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="عنوان"
              label-for="Title">
            <b-form-input
                v-model="title"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group
              label="رژیم"
              label-for="specialDietId">
            <z-special-diet
                v-model="specialDietId"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
              label="متد رژیم"
              label-for="DietMethod"
          >
            <v-select
                v-model="DietMethod"
                dir="rtl"
                :reduce="x => x.value"
                label="text"
                input-id="DietMethod"
                :clearable="false"
                :options="enums('DietMethod')"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <assign-term-to-nutritionist
        :show.sync="showNutritionistModal"
        :item="editingItem"
        @done="update"
    />
  </b-card>
</template>

<script>

import ZSpecialDiet from '@/tools/specialdiet.vue'
import AssignTermToNutritionist from "@/views/menu/user/nutritionist/AssignTermToNutritionist.vue";
import nutritionistForm from "@/views/menu/user/nutritionist/nutritionistForm.vue";
import NutritionistSelect from "@/tools/nutritionistSelect.vue";
import DynamicSelect from "@/tools/dynamicSelect.vue";

export default {
  name: "UserSpecialDiet",
  components: {
    DynamicSelect,
    nutritionistForm,
    ZSpecialDiet,
    AssignTermToNutritionist,
    NutritionistSelect,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      isShow: false,
      row: null,
      specialDietId: null,
      DietMethod: null,
      DietType: null,
      title: null,
      filterOptions: {
        UserId: null,
        Username: null,
        Title: null,
        Page: 1,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
        DietDurationId: null,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'StartDate',
          label: 'تاریخ شروع',
        },
        {
          key: 'Nutritionist',
          label: 'کارشناس تغذیه',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ ایجاد',
        },
        {
          key: 'actions',
          label: 'مدیریت رژیم 1',
          thClass: 'col-width-50',
        },
           {
          key: 'dietManager2',
          label: 'مدیریت رژیم 2',
        },
      ],
      items: [],
      editingItem: null,
      showNutritionistModal: false,
      processing: false,
      counter: 1,
      downloading: [],
      excelLoading: false,
      colors: [
        'success',
        'info',
        'primary',
        'secondary',
        'warning',
      ]
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  computed:{
    filteredDietTypes(){
      // { key: 'FastingWithExpert', text: 'رژیم فستینگ با کارشناس', value: 2 },
      // { key: 'WithExpert', text: 'رژیم با کارشناس', value: 4 },
      // { key: 'SportDiet', text: 'رژیم ورزشی با کارشناس', value: 11 }

      return this.enums('DietType').filter(i => [2, 4, 11].includes(i.value))
    }
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.userspecialdiet.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data.map(item => {
              return {
                ...item,
                Nutritionist: item.NutritionistUser ? `${item.NutritionistUser.Name} ${item.NutritionistUser.Family}` : null
              }
            })

            this.items.forEach(item => {
              if (item.IsDeactive) {
                item.User.Status = 10
              }
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    showModal(row) {
      this.row = row
      this.isShow = true
      this.title = null
      this.specialDietId = null
      this.DietMethod = null
      this.DietType = null
    },
    save(){
      this.$http.post(
          this.$api.userspecialdiet.add, {
            Title: this.title,
            SpecialDietId: this.specialDietId,
            UserDietTermId: this.row.Id,
            DietMethod: this.DietMethod,
            DietType: this.DietType,
            ParentId : this.row?.UserSpecialDiet?.Id || null
          },
      )
          .then(res => {
            this.update()
          })
    },
    remove(id) {
      this.removeRow(this.$api.userspecialdiet.remove, 'Id', id)
    },
    updateNutritionist(item) {
      this.editingItem = item
      this.showNutritionistModal = true
    },
    openNewTicket(item) {
      this.$bvModal.msgBoxConfirm('آیا مطمئن هستید که می خواهید تیکت جدید باز کنید؟', {
        size: 'sm',
        okVariant: 'primary',
        okTitle: this.$t('common.confirm'),
        cancelTitle: this.$t('common.cancel'),
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      }).then(confirm => {
        if (confirm) {
          this.$http.post(
              this.$api.ticket.openTicket, {
                UserId: item.User.Id,
                Title: 'رژیم درمانی',
                TicketDepartmentId: 17
              },
          ).then(res => {
            let route = this.$router.resolve({ name: 'ticketReply', params: { id: res.data.Id }})
            window.open(route.href, '_blank')
          })
        }
      })
    },
    exportExcel(){
      this.excelLoading = true
      let filename = 'userspecialdiet.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = () =>{
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
          this.excelLoading = false
          let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()
          }
      }
      let url = new URL(window.location.origin +'/api/' +  this.$api.userspecialdiet.excel)
      url.searchParams.set('FromDate', this.$moment(this.filterOptions.FromDate).format('YYYY-MM-DD'));
      url.searchParams.set('ToDate', this.$moment(this.filterOptions.ToDate).format('YYYY-MM-DD'));
      xmlHttpRequest.open("GET", url)
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send()
    },
    downloadPdf(id) {
      this.downloading.push(id)
      this.$http.get('/userspecialdiet/pdf/get', { params: { Id:id } }).then(response => {
        window.open(response.data, '_blank')
      }).finally(() => {
        this.downloading.splice(this.downloading.indexOf(id), 1)
      })
    },
    generatePdf(id){
      this.downloading.push('g'+id)
      this.$http.post('/userspecialdiet/pdf/regenerate', {Id:id}).then(response => {
        this.update()
      }).finally(() => {
        this.downloading.splice(this.downloading.indexOf('g'+id), 1)
      })
    }

  }
}
</script>
